import React from "react";
import { connect } from "react-redux";
import TableHead from "../../components/shared/table/CouponTableHead";
import Loading from "../../components/shared/loaders/Loading";
import { fullDate } from "../../helpers/DateTimeHelper";
import PaginationButtons from "../../components/shared/buttons/PaginationButtons";
import { toggleFailedSiteFilter } from "../failed-site-transactions/FailedSite-Action";
import store from "../../Store";
import ResponsiveModalForm from "../../components/shared/modals/ResponsiveModalForm";
import axios from "axios";
import { apiBaseUrl } from "../../helpers/UrlHelper";
import { loginToken } from "../../helpers/LocalStorageHelper";
import { ucFirst } from "../../helpers/StringHelper";
import ViewSingleSite from "../failed-site-transactions/ViewSingleSite";
import UpdateStatus from "../failed-site-transactions/UpdateStatus";
import { withRouter } from "react-router";
import {
  toggleSiteFailedFilter,
  toggleSiteFailedModal,
  toggleSiteFailedStatusModal,
} from "./SiteFailed-Action";
import { handleError } from "../../helpers/ErrorHelper";

class SiteFailedTransactions extends React.Component {
  state = {
    selectedTransaction: null,
    modalLoading: false,
    id: null,
  };

  async handleOpenModal(id) {
    this.setState({ modalLoading: true, selectedTransaction: null });

    store.dispatch(toggleSiteFailedModal({ mode: true }));
    axios({
      url: apiBaseUrl(`admin/failed-site-transactions/${id}`),
      method: "get",
      dataType: "json",
      headers: { Authorization: "Bearer " + loginToken() },
    })
      .then((res) => {
        this.setState({
          selectedTransaction: res?.data?.data,
          modalLoading: false,
        });
      })
      .catch((err) => {
        this.setState({ modalLoading: false });
        handleError(err?.data?.message);
      });
  }

  toggleSort = (field) => {
    store.dispatch(
      toggleSiteFailedFilter(
        {
          target: { name: `sort_by`, value: field },
        },
        this.props?.match?.params?.history,
        this.props?.match?.params?.id
      )
    );
  };

  render() {
    const {
      fields,
      params,
      modal,
      lists,
      getSiteFailedTnx,
      pages,
      status_modal,
      org_id,
    } = this.props;
    const { processing, error } = getSiteFailedTnx;

    if (error) {
      this.props.history.push("/");
    }

    return (
      <div className="tab-content">
        <div className="tab-pane fade show active">
          <div className="table-block table-responsive pr-60 table-list-block">
            <table className="table table-striped">
              <TableHead
                fields={fields}
                params={params}
                noActions={true}
                onClick={this.toggleSort}
              />
              <tbody>
                {processing ? (
                  <td colSpan="6" className="text-center">
                    <Loading />
                  </td>
                ) : lists && lists.length ? (
                  lists.map((list) => {
                    return (
                      <tr key={list.id}>
                        <td>{list.job_id}</td>
                        <td>{list.event}</td>
                        <td>{fullDate(list.created_at)}</td>
                        <td>{fullDate(list.updated_at)}</td>
                        <td>{ucFirst(list.status)}</td>
                        <td>
                          {
                            <div className="dropdown dropdown-alt text-center">
                              <span
                                className="dropdown-toggle"
                                data-toggle="dropdown"
                              >
                                <span className="icon-more" />
                              </span>
                              <div className="dropdown-menu">
                                <a
                                  href="javascript:void(0);"
                                  onClick={() => this.handleOpenModal(list.id)}
                                >
                                  View
                                </a>
                                <a
                                  href="javascript:void(0);"
                                  className={`update-status`}
                                  onClick={() => {
                                    store.dispatch(
                                      toggleSiteFailedStatusModal({
                                        mode: true,
                                      })
                                    );
                                    this.setState({ id: list.id });
                                  }}
                                >
                                  Update Status
                                </a>
                              </div>
                            </div>
                          }
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No Failed Site Transactions Available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <ResponsiveModalForm
              visible={modal.mode}
              closeModal={() => store.dispatch(toggleSiteFailedModal())}
            >
              {this.state.modalLoading ? (
                <div className="text-center">
                  <Loading />
                </div>
              ) : (
                <ViewSingleSite
                  data={this.state.selectedTransaction}
                  title="Failed Site Transactions"
                />
              )}
            </ResponsiveModalForm>
            <ResponsiveModalForm
              visible={status_modal.mode}
              closeModal={() => store.dispatch(toggleSiteFailedStatusModal())}
            >
              <UpdateStatus id={this.state.id} title="Site Failed" />
            </ResponsiveModalForm>
          </div>
          {lists && lists.length ? (
            <>
              <div className="fixed-footer pr-60" id="inside-site-pagination">
                <PaginationButtons
                  pages={pages}
                  processing={processing}
                  fetchAction={toggleFailedSiteFilter}
                />
              </div>
            </>
          ) : null}
        </div>
        {/* <SiteFailedWorker org_id={org_id} /> */}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { siteFailedTnxList, getSiteFailedTnx, getOrganization } = state;
  const org_id = getOrganization?.success?.id;
  const { success } = getSiteFailedTnx;
  const { params, fields, modal, status_modal } = siteFailedTnxList.data;

  const lists = success && success.data;

  const current_page = success && success.current_page;
  const last_page = success && success.last_page;
  const total = success && success.total;
  const pages = { current_page, last_page, total };

  return {
    getSiteFailedTnx,
    lists,
    modal,
    pages,
    params,
    fields,
    status_modal,
    org_id,
  };
}

export default withRouter(connect(mapStateToProps)(SiteFailedTransactions));
